import moment from "moment-timezone";

/*
The validation offered by the react-datetime component used for the DatePicker and TimePicker
isn't sufficient, so currently we're using this function for date validation.
Further explanation for the reasoning behind that can be found at:
https://axioscode.atlassian.net/browse/EDEN-1711?focusedCommentId=14574&page=com.atlassian.jira.plugin.system.issuetabpanels%3Acomment-tabpanel#comment-14574
*/

export default date => {
  if (!date) {
    return new Error("Date and time are required");
  }

  if (date.isSameOrBefore(moment(), "minute")) {
    return new Error("Select a date and time in the future");
  }
};
